import * as yup from 'yup'
import { REQUIRED_FIELD } from './validation/constants'

export const userSchema = yup
  .object({
    firstname: yup
      .string()
      .ensure()
      .required(REQUIRED_FIELD),
    lastname: yup
      .string()
      .ensure()
      .required(REQUIRED_FIELD),
    userEmail: yup
      .string()
      .ensure()
      .email()
      .required(REQUIRED_FIELD),
    userPhone: yup
      .string()
      .ensure()
      .required(REQUIRED_FIELD),
  })
  .transform(function(value) {
    return {
      ...value,
      userEmail: value.email || value.unverifiedEmail,
      userPhone: value.phone || value.unverifiedPhone,
    }
  })



// WEBPACK FOOTER //
// ./src/utils/user.js